<div class="container-area">
  <div id="simple-bar-chart" #simpleBarChart></div>
  <div *ngIf="!DataChartBar.load" class="container-loader-chart">
    <div class="loader loader-1 chart">
      <div class="loader-outter chart"></div>
      <div class="loader-inner chart"></div>
    </div>
  </div>
</div>
